import PropTypes from 'prop-types';
import * as React from 'react';

const Eye = React.forwardRef(({ color = 'currentColor', size, strokeWidth = 1.2, ...rest }, ref) => {
  const DEFAULT_W = 22;
  const DEFAULT_H = 18;
  const width = size ?? DEFAULT_W;
  const height = size ?? DEFAULT_H;
  const stroke = color === 'inherit' ? 'currentColor' : color;

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 22 18"
      fill="none"
      stroke={stroke}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      pointerEvents="none"
      {...rest}
    >
      <path d="M1.035 9.322a1 1 0 0 1 0-.639C2.423 4.51 6.361 1.5 11.001 1.5c4.637 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C19.576 13.49 15.64 16.5 11 16.5c-4.638 0-8.574-3.007-9.964-7.178" />
      <path d="M14 9a3 3 0 1 1-6 0 3 3 0 0 1 6 0" />
    </svg>
  );
});

Eye.displayName = 'Eye';

Eye.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default Eye;
